import React, { useState, useMemo, useEffect } from 'react';
import Grid from '@lsq/nextgen/v2/grid';
import styles from './TeamsTableWrapper.module.css';

const PAGE_SIZE_OPTIONS = [
  { label: '10', value: '10' },
  { label: '25', value: '25' },
  { label: '50', value: '50' }
];

/**
 * Shared table wrapper for Teams and WebTeams pages
 * Uses NextGen Grid with pagination
 */
const TeamsTableWrapper = ({
  data = [],
  columnDefs = [],
  loading = false,
  gridKey = 'teams-table',
  dataTestId = 'teams-table-grid'
}) => {
  const [pageSelected, setPageSelected] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Reset to page 1 when data changes
  useEffect(() => {
    setPageSelected(1);
  }, [data.length]);

  // Paginate data
  const pagedRecords = useMemo(() => {
    const start = (pageSelected - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, pageSelected, pageSize]);

  // Pagination configuration
  const paginationConfig = useMemo(
    () => ({
      pageSelected,
      pageSize,
      noOfRecords: pagedRecords.length,
      totalRecords: data.length,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      handlePageSelect: setPageSelected,
      handlePageSizeSelection: (option) => {
        const nextSize = parseInt(option?.value ?? option, 10) || 10;
        setPageSize(nextSize);
        setPageSelected(1);
      }
    }),
    [pageSelected, pageSize, pagedRecords.length, data.length]
  );

  return (
    <Grid
      gridKey={gridKey}
      gridClass={styles.teamsGrid}
      records={pagedRecords}
      columnDefs={columnDefs}
      paginationConfig={paginationConfig}
      dataTestId={dataTestId}
      loading={loading}
    />
  );
};

export default TeamsTableWrapper;
